<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-space-between"> 
                        <span>
                            <v-icon left>mdi-format-list-bulleted</v-icon>
                            Lista de Tratamientos Color para lentes de sol
                        </span>
                        <v-btn color="primary" @click="handleAddTratamientoColor">
                            <v-icon left>mdi-plus</v-icon>
                            Nuevo Tratamiento Color
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <!-- Filtros de busqueda -->
                        <v-row>
                            <v-col cols="12" md="8">
                                 <v-text-field
                                    label="Buscar por nombre"
                                    v-model="filtros.search"
                                    @keyup.enter="getData"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex align-center gap-2">
                                <v-btn color="primary" @click="getData">Buscar</v-btn>
                                <v-btn color="secondary" @click="resetFilters">Limpiar</v-btn>
                            </v-col>
                        </v-row>


                        <v-data-table
                            :headers="table.headers"
                            :items="table.data.data"
                            :options.sync="table.options"
                            :items-per-page="table.options.itemsPerPage"
                            :server-items-length="table.data.total"
                            class="elevation-1"
                            @update:options="changeOptionsTable"
                        >
                            <template v-slot:item.idtratamiento_color="{ item }">
                                {{ formatCode(item.idtratamiento_color) }}
                            </template>

                            <template v-slot:item.contenido="{ item }">
                                {{ reduceText(item.contenido, 50) }}
                            </template>

                            <!-- <template v-slot:item.imagen="{ item }">
                                <v-img
                                    v-if="item.imagen"
                                    :src="assetAWS(item.imagen)"
                                    width="100"
                                    height="50"
                                    contain
                                    class="bg-img-tenue"
                                />
                                <span v-else>Sin imagen</span>
                            </template> -->

                            <template v-slot:item.tratamiento="{ item }">
                                {{ item.tratamiento?.nombre || 'N/A' }}
                            </template>

                            <template v-slot:item.estado="{ item }">
                                <v-chip :color="item.estado == 1 ? 'green' : 'red'" dark>
                                    {{ item.estado == 1 ? 'Activo' : 'Inactivo' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.acciones="{ item }">
                                <div class="d-flex gap-2">
                                    <v-btn icon small color="primary" @click="handleEditTratamientoColor(item)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon small color="red" @click="handleDeleteTratamientoColor(item)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>

                            </template>
                                        

                            <template v-slot:no-data>
                                No hay tratamientos para mostrar
                            </template>

                        </v-data-table>


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <!-- Modal nuevo tratamiento color -->
        <ModalCard
            v-model="modal.addTratamientoColor.show"
            max-width="900px"
            @cancel="resetModal('addTratamientoColor')"
            >
            <template #title>
                <v-icon left>mdi-plus</v-icon>
                Nuevo Tratamiento Modal
            </template>

            <FormTratamientoColor
                class="p-form"
                v-model="modal.addTratamientoColor.tratamientoColor"
                :tratamientos="resources.tratamientos"
                @submit="handleStoreTratamientoColor"
                @cancel="resetModal('addTratamientoColor')"
            />
        </ModalCard>

        <!-- Modal editar tratamiento color -->
        <ModalCard
            v-model="modal.editTratamientoColor.show"
            max-width="900px"
            @cancel="resetModal('editTratamientoColor')"
            >
            <template #title>
                <v-icon left>mdi-pencil</v-icon>
                Editar Tratamiento Modal #{{ formatCode(modal.editTratamientoColor.tratamientoColor?.idtratamiento_color || '') }}
            </template>

            <FormTratamientoColor
                class="p-form"
                v-model="modal.editTratamientoColor.tratamientoColor"
                :tratamientos="resources.tratamientos"
                @submit="handleUpdateTratamientoColor"
                @cancel="resetModal('editTratamientoColor')"
            />
        </ModalCard>

        <!-- Modal eliminar tratamiento color -->
        <ModalDelete
            v-model="modal.deleteTratamientoColor.show" 
            @destroy="handleDestroyTratamientoColor"
            @cancel="resetModal('deleteTratamientoColor')"
        />
    </v-container>
</template>

<script >
    import tratamientoColorService from '@/services/tratamientoColorService';
    import { tratamientoColor } from '@/models/tratamientoColor';

    import ModalCard from '@/components/ModalCard.vue';
    import ModalDelete from '@/components/ModalDelete.vue';
    import FormTratamientoColor from '@/components/tratamientos/color/FormTratamientoColor.vue';

    const modals = _ => ({
        addTratamientoColor: {
            show: false,
            loading: false,
            tratamientoColor: null,
        },
        editTratamientoColor: {
            show: false,
            loading: false,
            tratamientoColor: null,
        },
        deleteTratamientoColor: {
            show: false,
            loading: false,
            tratamientoColor: null,
        },
    })

    export default {
        name: "TratamientosModalIndex",
        components: {
            ModalCard,
            ModalDelete,
            FormTratamientoColor,
        },
        data() {
            return {
                resources: {
                },
                table: {
                    headers: [
                        { text: 'ID', value: 'idtratamiento_color' },
                        { text: 'Tratamiento', value: 'tratamiento' },
                        { text: 'Nombre', value: 'nombre' },
                        // { text: 'Imagen', value: 'imagen' },
                        { text: 'Posición', value: 'posicion' },
                        { text: 'Estado', value: 'estado' },
                        {
                            text: 'Acciones',
                            value: 'acciones',
                            align: 'center',
                            sortable: false,
                        }
                    ],
                    options: {
                        page: 1,
                        itemsPerPage: 15,
                        sortBy: [],
                        sortDesc: [],
                    },
                    data: {
                        data: [],
                        total: 0,
                    }

                },
                filtros: {
                    search: '',
                },
                modal: modals(),
            }
        },
        methods: {
            async getData() {

                const options = this.table.options;

                const page = options.page || 1;
                const perPage = options.itemsPerPage || 15;
                const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : null;
                const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
                const search = this.filtros.search || '';


                try {
                    const res = await tratamientoColorService.paginate({
                        page: page,
                        per_page: perPage,
                        search: search,
                        sort_by: sortBy,
                        sort_desc: sortDesc !== null ? (sortDesc ? 'desc' : 'asc') : null,
                    });
                    this.table.data = res.data;

                    
                } catch (error) {
                    console.error(error);
                }
            },

            changeOptionsTable(options) {
                this.table.options = options;
                this.getData();
            },


            resetOptionsTable() {
                this.table.options.page = 1;
                this.table.options.itemsPerPage = 15;
                this.table.options.sortBy = [];
                this.table.options.sortDesc = [];
            },

            resetFilters() {
                this.filtros.search = '';

                this.resetOptionsTable();
                this.getData();
            },


            async fetchCreate() {
                try {
                    const response = await tratamientoColorService.create();
                    this.resources.tratamientos = response.data.tratamientos;

                } catch (error) {
                    this.handleErrorApi(error);
                }
            },


            handleAddTratamientoColor() {
                
                this.modal.addTratamientoColor.tratamientoColor = {...tratamientoColor };
                this.modal.addTratamientoColor.show = true;
            },
            handleEditTratamientoColor(tratamientoColor) {
                this.modal.editTratamientoColor.tratamientoColor = tratamientoColor;
                this.modal.editTratamientoColor.show = true;
            },
            handleDeleteTratamientoColor(tratamientoColor) {
                this.modal.deleteTratamientoColor.tratamientoColor = tratamientoColor;
                this.modal.deleteTratamientoColor.show = true;
            },


            async handleStoreTratamientoColor(form) {

                try {

                    const formData = new FormData();
                    for (const key in form) {
                        if (form[key] !== undefined && form[key] !== null) {
                            formData.append(key, form[key]);
                        }
                    }

                    const response = await tratamientoColorService.store(formData);
                    
                    this.table.options.page = 1;
                    await this.getData();

                    this.resetModal('addTratamientoColor');
                    this.$toasted.success('Modal creado correctamente.');

                } catch (error) {
                    this.handleErrorApi(error);
                }
            },
            async handleUpdateTratamientoColor(form) {
                console.log("🚀 ~ form:", form)
                try {
                    const formData = new FormData();
                    formData.append('_method', 'PUT');
                    for (const key in form) {
                        if (form[key] !== undefined && form[key] !== null) {
                            formData.append(key, form[key]);
                        }
                    }

                    const response = await tratamientoColorService.update(form.idtratamiento_color, formData);
                    
                    await this.getData();

                    this.resetModal('editTratamientoColor');
                    this.$toasted.success('Modal actualizado correctamente.');
                } catch (error) {
                    this.handleErrorApi(error);
                }
            },
            async handleDestroyTratamientoColor() {
                try {
                    const modal = this.modal.deleteTratamientoColor.tratamientoColor;

                    const formData = new FormData();
                    formData.append('_method', 'DELETE');
                    
                    await tratamientoColorService.destroy(modal.id, formData);

                    this.table.options.page = 1;
                    await this.getData();

                    this.resetModal('deleteTratamientoColor');
                    this.$toasted.success('Modal eliminado correctamente.');
                } catch (error) {
                    this.handleErrorApi(error);
                }
            },

            resetModal(modalName) {
                const modales = modals();

                if ( !modales.hasOwnProperty(modalName) ) {
                    console.warn(`El modal ${modalName} no existe.`);
                    return;
                }

                this.modal[modalName] = modales[modalName];
            }
        },
        mounted() {
            this.fetchCreate();
        }
    }
</script>

<style scoped>
    .gap-2 {
        gap: 8px;
    }
</style>